import React, { useState } from "react";
import { CheckIcon } from "@heroicons/react/20/solid";

const includedFeaturesDietetique = [
  "Analyse de l'alimentation, de l'activité physique et de l'hygiène de vie globale",
  "Conseils et plan d'action personnalisés",
  "Suivi régulier",
];

const includedFeaturesProgramme = [
  "Programme d'entraînement complet",
  "PDF téléchargeable",
  "Adaptable et flexible",
];

const includedFeaturesSeance = [
  "1h de séance coachée",
  "Conseils personnalisés",
  "Suivi des progrès",
  "Encadrement sécurisé",
];

export default function SlidePricing() {
  const [selected, setSelected] = useState("M");

  return (
    <section
      id="tarifs"
      className="w-full text-black bg-white px-4 lg:px-8 pt-12 lg:pt-24 relative overflow-hidden mx-auto max-w-7xl"
    >
      <Heading selected={selected} setSelected={setSelected} />
      <PriceCards selected={selected} />
    </section>
  );
}

const Heading = ({ selected, setSelected }) => {
  return (
    <div className="mb-12 lg:mb-24 relative z-10">
      <h3 className="font-bold font-sans text-h2 uppercase lg:text-7xl text-center mb-6">
        tous les tarifs
      </h3>
      <p className="text-center mx-auto max-w-lg mb-8">
        Trouve la formule qui te correspond en fonction de tes objectifs.
      </p>
    </div>
  );
};

const PriceCards = ({ selected }) => (
  <div className="flex flex-col lg:flex-row gap-8 lg:gap-4 w-full mx-auto relative z-10">
    {/* FREE */}
    <div className="w-full bg-white p-10 border-[1px] rounded-3xl  ring-gray-200">
      <p className="text-crd-title font-bold uppercase font-sans mb-8">
        Consultation <br /> en visio
      </p>

      <p className="text-h2 font-sans font-bold mb-8">40€</p>
      <div className="mt-10 flex items-center gap-x-4">
        <h4 className="flex-none text-sm font-semibold leading-6 text-[#9BDAF2]">
          Cette prestation contient
        </h4>
        <div className="h-px flex-auto bg-gray-100" />
      </div>
      <ul className="mt-8  gap-4 text-sm leading-6 text-[#020617] sm:gap-6">
        {includedFeaturesDietetique.map((feature) => (
          <li key={feature} className="flex gap-x-3 pb-2">
            <CheckIcon
              aria-hidden="true"
              className="h-6 w-5 flex-none text-[#9BDAF2]"
            />
            {feature}
          </li>
        ))}
      </ul>
    </div>

    {/* PRO  */}
    <div className="w-full bg-white p-10 border-[1px] rounded-3xl  ring-gray-200">
      <p className="text-crd-title font-bold uppercase font-sans mb-8">
        Programme <br />
        sportif
      </p>

      <p className="text-h2 font-sans font-bold mb-8">60€</p>
      <div className="mt-10 flex items-center gap-x-4">
        <h4 className="flex-none text-sm font-semibold leading-6 text-[#9BDAF2]">
          Cette prestation contient
        </h4>
        <div className="h-px flex-auto bg-gray-100" />
      </div>
      <ul className="mt-8 gap-4 text-sm leading-6 text-[#020617] sm:gap-6">
        {includedFeaturesProgramme.map((feature) => (
          <li key={feature} className="flex gap-x-3 pb-2">
            <CheckIcon
              aria-hidden="true"
              className="h-6 w-5 flex-none text-[#9BDAF2]"
            />
            {feature}
          </li>
        ))}
      </ul>
    </div>

    {/* ENTERPRISE */}
    <div className="w-full bg-white p-10 border-[1px] rounded-3xl  ring-gray-200">
      <p className="text-crd-title font-bold uppercase font-sans mb-8">
        Séance <br />
        de sport
      </p>

      <p className="text-h2 font-sans font-bold mb-8">45€</p>
      <div className="mt-10 flex items-center gap-x-4">
        <h4 className="flex-none text-sm font-semibold leading-6 text-[#9BDAF2]">
          Cette prestation contient
        </h4>
        <div className="h-px flex-auto bg-gray-100" />
      </div>
      <ul className="mt-8  gap-4 text-sm leading-6 text-[#020617]  sm:gap-6">
        {includedFeaturesSeance.map((feature) => (
          <li key={feature} className="flex gap-x-3 pb-2">
            <CheckIcon
              aria-hidden="true"
              className="h-6 w-5 flex-none text-[#9BDAF2]"
            />
            {feature}
          </li>
        ))}
      </ul>
    </div>
  </div>
);
